import React, { useState, useEffect } from "react";
import Pagination from "../../components/global/pagination/Pagination.jsx";
import columns from "../../columns/DepositReminderLog.js";
import TableWithSkeleton from '../../components/global/table/TableWithSkeleton.jsx';
import { DepositReminderLogApi } from '../../api/request/ibCommission.js';
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default function DepositReminderLog() {

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [sorter, setSorter] = useState({ SortBy: 'timestamp', SortOrder: '' });

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'timestamp', SortOrder: '' });
    }
  };


  const getDepositReminder = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        ...sorter
      }
      setIsLoading(true);
      const { data } = await DepositReminderLogApi(new URLSearchParams(params).toString());
      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            timestamp: moment(item?.timestamp).format('DD-MM-YYYY, hh:mm A'),
          };
        })
      );
      setTotalRecord(data?.totalRecords);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getDepositReminder();
  }, [page, pageSize, sorter]);

  return (
    <div className="my-6">
      <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
        <TableWithSkeleton
          columns={columns}
          data={data}
          loading={isLoading}
          page={page}
          pageSize={pageSize}
        />
      </div>
      <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
    </div>
  )
}
